/**
 * English (GB) PDF Templates
 *
 * Export all English PDF templates from this index file.
 */

export { advisoryMultiPortfolioStandard } from "./advisory-multi-portfolio";
export { helloWorld } from "./hello-world";
